// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import './Footer.css';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaLinkedinIn, 
  FaShieldAlt,
  FaRocket,
  FaUsers,
  FaArrowUp,
  FaWhatsapp
} from 'react-icons/fa';

const Footer = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setShowScrollTop(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      {/* Background Pattern */}
      <div className="footer-background">
        <div className="footer-pattern"></div>
      </div>

      <div className="footer-content">
        {/* Main Footer Sections */}
        <div className="footer-sections">
          {/* Company Info */}
          <div className="footer-section company-section">
            <div className="footer-logo">
              <FaShieldAlt className="logo-icon" />
              <h3>G3 Rastreamento</h3>
            </div>
            <p className="company-description">
              Soluções completas em rastreamento e gestão de frotas, garantindo a segurança e tranquilidade dos nossos clientes desde 2014.
            </p>
            <div className="company-features">
              <div className="feature-item">
                <FaShieldAlt className="feature-icon" />
                <span>Segurança Garantida</span>
              </div>
              <div className="feature-item">
                <FaRocket className="feature-icon" />
                <span>Tecnologia de Ponta</span>
              </div>
              <div className="feature-item">
                <FaUsers className="feature-icon" />
                <span>Suporte 24/7</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>Links Rápidos</h3>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">Sobre Nós</a></li>
              <li><a href="/services">Serviços</a></li>
              <li><a href="/contracts">Contratos</a></li>
              <li><a href="/scheduling">Agendamento</a></li>
              <li><a href="/contact">Contato</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3>Nossos Serviços</h3>
            <ul className="footer-links">
              <li>Rastreamento Veicular</li>
              <li>Plano Moto +</li>
              <li>Assistência Veicular</li>
              <li>Gestão de Frotas</li>
              <li>Monitoramento 24/7</li>
              <li>Relatórios Avançados</li>
            </ul>
          </div>


        </div>

        {/* Social Media & Newsletter */}
        <div className="footer-actions">
          <div className="social-section">
            <h4>Siga-nos nas Redes Sociais</h4>
            <div className="social-links">
              <a href="https://web.facebook.com/p/G3-Rastreamento-100076258940633/?_rdc=1&_rdr#" 
                 className="social-link facebook"
                 target="_blank"
                 rel="noopener noreferrer"
                 aria-label="Facebook">
                <FaFacebookF className="social-icon" />
              </a>
              <a href="https://www.instagram.com/g3rastreamento/" 
                 className="social-link instagram"
                 target="_blank"
                 rel="noopener noreferrer"
                 aria-label="Instagram">
                <FaInstagram className="social-icon" />
              </a>
              <a href="#" 
                 className="social-link linkedin"
                 target="_blank"
                 rel="noopener noreferrer"
                 aria-label="LinkedIn">
                <FaLinkedinIn className="social-icon" />
              </a>
              <a href="https://wa.me/5585999835383" 
                 className="social-link whatsapp"
                 target="_blank"
                 rel="noopener noreferrer"
                 aria-label="WhatsApp">
                <FaWhatsapp className="social-icon" />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>© 2026 G3 Rastreamento. Todos os direitos reservados.</p>
            </div>
            <div className="footer-legal">
              <a href="/privacy">Política de Privacidade</a>
              <span className="separator">•</span>
              <a href="/terms">Termos de Uso</a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button 
        className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`} 
        onClick={scrollToTop} 
        aria-label="Voltar ao topo"
      >
        <FaArrowUp className="scroll-icon" />
      </button>
    </footer>
  );
};

export default Footer;